import styled from 'styled-components';

const NoSearchesText = styled.p`
  ${({ theme }) => theme.fontSize.M14};
  color: ${({ theme }) => theme.colors.GREY_DARK};
  text-align: center;
`;

export { NoSearchesText };
